import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setUser, clearUser } from "../redux/features/userSlice";
import axios from "axios";

export default function AdminRoute({ children }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const token    = localStorage.getItem("token");

  useEffect(() => {
    /* If token exists but Redux user not loaded yet — fetch it */
    if (!token || user) return;

    let cancelled = false;
    axios
      .post("/api/user/getUserData", {}, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (!cancelled) {
          if (res.data?.success) {
            dispatch(setUser(res.data.data.user));
          } else {
            localStorage.removeItem("token");
            dispatch(clearUser());
          }
        }
      })
      .catch(() => {
        if (!cancelled) {
          localStorage.removeItem("token");
          dispatch(clearUser());
        }
      });

    return () => { cancelled = true; };
  }, [token, user, dispatch]);

  /* No token — send to login */
  if (!token) return <Navigate to="/login" replace />;

  /* Token exists but user not loaded yet — show nothing while fetching */
  if (!user) return null;

  /* Logged in but not admin — send home */
  if (!user.isAdmin) return <Navigate to="/" replace />;

  return children;
}
